<style src="./ImportModel.scss" lang="scss"></style>
<template>
  <aside class="resut-import-model">

    <div
      class="drop-zone"
      @dragover="isDragOver"
      @dragenter="isDragOver"
      @dragleave="isDragLeave"
      @dragend="isDragLeave"
      @drop="isDrop"
      :class="{'drop-zone-over': dragOverClass}"
      v-show="uploadStage === 'UPLOAD'">
      <label class="input-label">
        <input
          type="file"
          class="input-file"
          accept=".xlsx"
          @change="isChoosed">

        <icon-upload class="icon"/>
        <h3>Respositório de arquivo</h3>
        <h5>Arraste o arquivo aqui ou clique para escolher</h5>
      </label>
    </div>

    <div
      class="wait"
      v-show="uploadStage === 'WAIT'">
      <icon-wait class="icon" />
      <h3>Processando o arquivo</h3>
      <h5>Aguarde...</h5>
    </div>
  </aside>
</template>

<script>
import { IconUpload, IconWait } from '@/components/primitives/icons'

import FileHandle from './FileHandle'
let file = null
export default {
  name: 'ImportModel',
  components: {
    IconUpload,
    IconWait
  },
  data: () => {
    return {
      dragOverClass: false,
      uploadStage: 'UPLOAD'
    }
  },
  methods: {
    isDragOver (e) {
      e.preventDefault()
      e.stopPropagation()

      if (!this.dragOverClass) this.dragOverClass = true
    },
    isDragLeave (e) {
      e.preventDefault()
      e.stopPropagation()

      if (this.dragOverClass) this.dragOverClass = false
    },
    isDrop (e) {
      e.preventDefault()
      e.stopPropagation()
      if (this.dragOverClass) this.dragOverClass = false
      this.readFile(e.dataTransfer.files[0])
    },
    isChoosed (e) {
      e.preventDefault()
      e.stopPropagation()
      this.readFile(e.target.files[0])
    },
    async readFile (pFile) {
      const eventId = this.$route.params.id
      file = pFile
      if (this.dragOverClass) this.dragOverClass = false
      this.uploadStage = 'WAIT'
      try {
        await FileHandle(file, eventId)
        await this.reloadItems()
        this.uploadStage = 'UPLOAD'
        this.$toasted.success('Resultado importado com sucesso')
      } catch (error) {
        this.uploadStage = 'UPLOAD'
      } finally {
        this.$emit('finish-upload')
      }
    },
    submit () {
      this.readFile(file)
    },
    async reloadItems () {
      const eventId = this.$route.params.id
      if (!eventId) return false
      await this.$store.dispatch('Result/LOAD_EVENT', { eventId })
      // this.computeFilters(items)
      // this.items = Object.freeze(items)
      // this.filteredItems = Object.freeze(items)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/event-result/components/import-model/ImportModel.vue